export default "__VITE_ASSET__DushOCn6__"